import React from "react";
import { User } from "@shared/models";
import { TableProperty } from "@shared/components/Table/interfaces";
import { getFullName, getUSFormatedDateTime } from "@shared/utils";
import { UserActions } from "@containers/Contact/components/ContactDeployListsContainer/ContactUsersTable/UserActions";
import { Icon } from "@shared/components";

export const clientsTableProperties: TableProperty<User & { is_primary?: boolean }>[] = [
  {
    title: "Name",
    key: "first_name",
    get: (item) => (
      <div className="table-client-name-cell">
        <span>{getFullName(item)}</span>
        {item.is_primary && <Icon type="star-black" className="icon" />}
      </div>
    ),
    cellClassName: "title-cell",
    headerClassName: "title-header-cell",
  },
  {
    title: "Status",
    key: "status",
    get: (item) => {
      const accountUserStatus = item.is_active_in_account ? "Active" : "Inactive";

      return (
        <div className={`table-client-status-cell ${accountUserStatus.toLowerCase()}`}>
          <span>{accountUserStatus}</span>
        </div>
      );
    },
  },
  {
    title: "Last Login",
    key: "last_account_login_at",
    cellClassName: "table-date-cell",
    headerClassName: "table-date-header",
    get: (item) => getUSFormatedDateTime(item.last_account_login_at),
  },
  {
    title: "Created at",
    key: "created_at",
    get: (item) => getUSFormatedDateTime(item.created_at),
    cellClassName: "table-date-cell",
    headerClassName: "table-date-header",
  },
  {
    title: " ",
    key: "id",
    get: (item) => <UserActions client={item} />,
    cellClassName: "table-show-onhover",
  },
];
